import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box,
  Typography,
  TextField,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { addSpecialImage, updateSpecialImage, fetchSpecialImageById } from "../../services/specialImage";

const AddImage = ({ onBack, onAdd, editImageId }) => {
  const [title, setTitle] = useState("");
  const [customTitle, setCustomTitle] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (editImageId) {
      fetchSpecialImageById(editImageId).then((data) => {
        setTitle(data.image_title);
        setCustomTitle(data.image_title === "other" ? data.image_title : "");
        setImageFile(data.image_url);
      }).catch((error) => {
        console.error("Error fetching image by ID:", error);
        setError("Error fetching image data.");
      });
    }
  }, [editImageId]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImageFile(file);
    console.log("File:", file);
  };

  const handleAddImage = async () => {
    const finalTitle = title === "other" ? customTitle : title;
    const formData = new FormData();
    formData.append("image_title", finalTitle);
    formData.append("image_url", imageFile);
    formData.append("image_alt", finalTitle); // Use the same value as image_title

    try {
      if (editImageId) {
        console.log("Edit Image ID:", editImageId);
        console.log("Form Data:", formData);
        const response = await updateSpecialImage(editImageId, formData);
        console.log("Image Updated", response);
        onAdd(response);
      } else {
        const response = await addSpecialImage(formData);
        console.log("New Image Added", response);
        onAdd(response);
      }
    } catch (error) {
      console.error("Error adding/updating image:", error);
      setError("Error adding/updating image.");
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIosIcon />}
        onClick={onBack}
        sx={{ mb: 2 }}
      >
        Back
      </Button>
      <Container maxWidth="sm">
        <Typography variant="h5" align="center" gutterBottom>
          {editImageId ? "Edit Image" : "Add Special Image"}
        </Typography>
        {error && (
          <Typography variant="body1" color="error" align="center" gutterBottom>
            {error}
          </Typography>
        )}
        <Paper sx={{ p: 2, mb: 2 }} elevation={3}>
          <FormControl fullWidth margin="normal" required>
            <InputLabel>Select a title</InputLabel>
            <Select
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              label="Image Title"
            >
              <MenuItem value="company logo">Company Logo</MenuItem>
              <MenuItem value="company signature">Company Signature</MenuItem>
              <MenuItem value="banner">Company Banner</MenuItem>
              <MenuItem value="slider">Slider </MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
          {title === "other" && (
            <TextField
              fullWidth
              margin="normal"
              label="Custom Image Title"
              value={customTitle}
              onChange={(e) => setCustomTitle(e.target.value)}
              required
            />
          )}
          <Button
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
            sx={{ mt: 2 }}
          >
            Upload file
            <input
              type="file"
              onChange={handleFileChange}
              hidden
            />
          </Button>
          {imageFile && (
            <Box sx={{ mt: 2 }}>
              <Box
                component="img"
                src={typeof imageFile === "string" ? imageFile : URL.createObjectURL(imageFile)}
                alt="preview"
                sx={{
                  width: "100%",
                  height: 200,
                  objectFit: "contain",
                  borderRadius: 1,
                }}
              />
            </Box>
          )}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleAddImage}
          >
            {editImageId ? "Update Image" : "Add Image"}
          </Button>
        </Paper>
      </Container>
    </>
  );
};

export default AddImage;
